export default {
  homePage: require("./img/banner-homepage.jpg"),
  rainbowLogo: require("./img/rainbow_logo.png"),
};
